import {Box} from '@mui/material';
import PropTypes, {node} from 'prop-types';
import React, {useRef} from 'react';
import {Virtuoso} from 'react-virtuoso';
import UploadItem from './UploadItem.jsx';

const ListItem = ({children, ...props}) => {
  return (
    <Box
      {...props}
      style={{margin: 0}}
      sx={{
        paddingBottom: 1,
        paddingX: 2,
        '&:first-of-type': {
          paddingTop: 1,
        },
      }}
    >
      {children}
    </Box>
  );
};

ListItem.propTypes = {
  children: node,
};

const UploadsList = ({uploads}) => {
  const listRef = useRef();

  const renderUploadItem = index => {
    const upload = uploads[index];
    return <UploadItem key={upload.id} upload={upload} />;
  };

  return (
    <Virtuoso
      ref={listRef}
      totalCount={uploads?.length}
      itemContent={renderUploadItem}
      overscan={500}
      components={{
        Item: ListItem,
      }}
    />
  );
};

UploadsList.propTypes = {
  uploads: PropTypes.arrayOf(PropTypes.object),
};

export default UploadsList;
